import React from "react";
import ReactPaginate from "react-paginate";
import { useSolrContext } from "@e-fork/solr";

/**
 * Pagination component for displaying page navigation.
 * This component will calculate the number of pages and render a pagination.
 * Place it below the list of nodes in the overview component.
 */
const Pagination = () => {
  const { metaData, currentPage, setCurrentPage, config, setCurrentLimit } =
    useSolrContext();

  // Calculate the number of pages.
  const pageCount = metaData.pageCount || 0;

  // Don't render if there is only one page.
  if (pageCount === 0) return null;

  const pageChangeHandler = (event) => {
    setCurrentPage(event.selected);
  };

  const changeLimit = (e) => {
    const value = e.target.value;
    setCurrentLimit(value);
  };

  return (
    <div className="row">
      <div className="col-12 col-md-6 offset-md-3 d-flex justify-content-center">
        <div className="pagination">
          {!!config.limits?.length && (
            <select onChange={changeLimit} value={config.limit}>
              {config.limits.map((limit) => (
                <option value={limit}>{limit}</option>
              ))}
            </select>
          )}
          <ReactPaginate
            breakLabel="..."
            nextLabel="→"
            pageRangeDisplayed={5}
            onPageChange={pageChangeHandler}
            pageCount={pageCount}
            initialPage={currentPage}
            previousLabel="←"
            renderOnZeroPageCount={null}
          />
        </div>
      </div>
    </div>
  );
};

Pagination.propTypes = {};

export default Pagination;
